"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var browser_platform_location_1 = require('./src/browser/location/browser_platform_location');
exports.BrowserPlatformLocation = browser_platform_location_1.BrowserPlatformLocation;
var title_1 = require('./src/browser/title');
exports.Title = title_1.Title;
var tools_1 = require('./src/browser/tools/tools');
exports.disableDebugTools = tools_1.disableDebugTools;
exports.enableDebugTools = tools_1.enableDebugTools;
var by_1 = require('./src/dom/debug/by');
exports.By = by_1.By;
var ng_probe_1 = require('./src/dom/debug/ng_probe');
exports.ELEMENT_PROBE_PROVIDERS = ng_probe_1.ELEMENT_PROBE_PROVIDERS;
var dom_tokens_1 = require('./src/dom/dom_tokens');
exports.DOCUMENT = dom_tokens_1.DOCUMENT;
var dom_events_1 = require('./src/dom/events/dom_events');
exports.DomEventsPlugin = dom_events_1.DomEventsPlugin;
var event_manager_1 = require('./src/dom/events/event_manager');
exports.EVENT_MANAGER_PLUGINS = event_manager_1.EVENT_MANAGER_PLUGINS;
exports.EventManager = event_manager_1.EventManager;
var hammer_gestures_1 = require('./src/dom/events/hammer_gestures');
exports.HAMMER_GESTURE_CONFIG = hammer_gestures_1.HAMMER_GESTURE_CONFIG;
exports.HammerGestureConfig = hammer_gestures_1.HammerGestureConfig;
var key_events_1 = require('./src/dom/events/key_events');
exports.KeyEventsPlugin = key_events_1.KeyEventsPlugin;
var dom_sanitization_service_1 = require('./src/security/dom_sanitization_service');
exports.DomSanitizationService = dom_sanitization_service_1.DomSanitizationService;
exports.SecurityContext = dom_sanitization_service_1.SecurityContext;
__export(require('./src/browser'));
// Web Workers
var client_message_broker_1 = require('./src/web_workers/shared/client_message_broker');
exports.ClientMessageBroker = client_message_broker_1.ClientMessageBroker;
exports.ClientMessageBrokerFactory = client_message_broker_1.ClientMessageBrokerFactory;
exports.FnArg = client_message_broker_1.FnArg;
exports.UiArguments = client_message_broker_1.UiArguments;
var service_message_broker_1 = require('./src/web_workers/shared/service_message_broker');
exports.ReceivedMessage = service_message_broker_1.ReceivedMessage;
exports.ServiceMessageBroker = service_message_broker_1.ServiceMessageBroker;
exports.ServiceMessageBrokerFactory = service_message_broker_1.ServiceMessageBrokerFactory;
var serializer_1 = require('./src/web_workers/shared/serializer');
exports.PRIMITIVE = serializer_1.PRIMITIVE;
__export(require('./src/web_workers/shared/message_bus'));
var location_providers_1 = require('./src/web_workers/worker/location_providers');
exports.WORKER_APP_LOCATION_PROVIDERS = location_providers_1.WORKER_APP_LOCATION_PROVIDERS;
var location_providers_2 = require('./src/web_workers/ui/location_providers');
exports.WORKER_UI_LOCATION_PROVIDERS = location_providers_2.WORKER_UI_LOCATION_PROVIDERS;
__export(require('./src/worker_render'));
__export(require('./src/worker_app'));
__export(require('./private_export'));
var browser_2 = require('./src/browser');
/* @deprecated use BROWSER_PLATFORM_PROVIDERS */
exports.BROWSER_PROVIDERS = browser_2.BROWSER_PLATFORM_PROVIDERS;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/platform-browser/index.js
 ** module id = 224
 ** module chunks = 0
 **/